import { render, staticRenderFns } from "./fccSubJudice.vue?vue&type=template&id=fbf7a328"
import script from "./fccSubJudice.vue?vue&type=script&lang=js"
export * from "./fccSubJudice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports